import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import Api from "api/Api";
import Loader from "components/common/Loader";
import Toaster from "components/common/Toaster";

const TillTable = ({ branchId, ...props }) => {
  const [tblData, setTblData] = useState([]);
  const [loader, setLoader] = useState(false);
  const toaster = useRef();

  useEffect(() => {
    if (branchId) {
      fetchTills();
    }
  }, [branchId]);

  const fetchTills = () => {
    setLoader(true);
    Api.get(`/admin/branch/tills?branchId=${branchId}`)
      .then(res => {
        setTblData(res.data.data || []);
        setLoader(false);
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.message);
        setLoader(false);
      });
  };

  const columns = [
    {
      Header: "Till ID",
      accessor: "tillId",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 80
    },
    {
      Header: "Till Name",
      accessor: "tillName",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class"
    },
    {
      Header: "Vendor Code",
      accessor: "vendorTillCode",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class"
    },
    {
      Header: "Pairing Code",
      accessor: "pairingCode",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class"
    },
    {
      Header: "Username",
      accessor: "tillUsername",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      Cell: row => row.value || "-"
    },
    {
      Header: "Password",
      accessor: "tillPassword",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      Cell: row => row.value || "-"
    },
    {
      Header: "Status",
      accessor: "deviceTokenId",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 120,
      Cell: row => (
        <span
          style={{
            padding: "4px 10px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "600",
            backgroundColor: row.value ? "#d4edda" : "#fff3cd",
            color: row.value ? "#155724" : "#856404"
          }}
        >
          {row.value ? "Paired" : "Unpaired"}
        </span>
      )
    },
    {
      Header: "Device Token ID",
      accessor: "deviceTokenId",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 130,
      Cell: row => row.value || "-"
    },
    {
      Header: "Last Receipt ID",
      accessor: "lastReceiptId",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 130,
      Cell: row => row.value || "-"
    },
    {
      Header: "Active",
      accessor: "active",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 80,
      Cell: row => (
        <span style={{ color: row.value ? "green" : "red" }}>
          {row.value ? "Yes" : "No"}
        </span>
      )
    }
  ];

  return (
    <div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Till List
            </div>
          </div>
          <div className="roe-card-body">
            <ReactTable
              style={{ border: "none", boxShadow: "none" }}
              data={tblData}
              columns={columns}
              defaultPageSize={10}
              minRows={2}
              className="-striped -highlight custom-react-table-theme-class"
              loading={loader}
              LoadingComponent={Loader}
            />
          </div>
          <Toaster ref={toaster} />
        </div>
      </div>
    </div>
  );
};

export default withRouter(TillTable);

